import { useEffect, useState } from "react";
import { Mail, Instagram, Linkedin, MessageCircle, ArrowUpRight } from "lucide-react";
import Logo from "@/components/Logo";
import { Reveal } from "./Section";
import { scrollToId } from "@/lib/scroll";
import { api } from "@/lib/api";

const DEFAULTS = {
  email: "bishwa@bishwamohanpati.com",
  instagram: "https://www.instagram.com/mohan_journeys",
  linkedin: "https://www.linkedin.com/in/bishwa-mohan-pati-00b0031b4/",
  whatsapp: "+91 93489 28091",
};

const Footer = () => {
  const [profile, setProfile] = useState(DEFAULTS);
  useEffect(() => {
    api.get("/profile").then((r) => setProfile({ ...DEFAULTS, ...r.data })).catch(() => {});
  }, []);

  const waDigits = (profile.whatsapp || "").replace(/[^0-9]/g, "");
  const CONTACTS = [
    { icon: Mail, label: "Email", value: profile.email, href: `mailto:${profile.email}`, testid: "contact-email" },
    { icon: Instagram, label: "Instagram", value: "@mohan_journeys", href: profile.instagram, testid: "contact-instagram" },
    { icon: Linkedin, label: "LinkedIn", value: "Bishwa Mohan Pati", href: profile.linkedin, testid: "contact-linkedin" },
    { icon: MessageCircle, label: "WhatsApp", value: profile.whatsapp, href: `https://wa.me/${waDigits}`, testid: "contact-whatsapp" },
  ].filter((c) => c.value);

  return (
    <footer id="contact" className="relative border-t border-white/8 bg-[#080A0E]" data-testid="contact-footer">
      <div className="mx-auto max-w-7xl px-5 md:px-8 py-24">
        <div className="grid gap-14 lg:grid-cols-[1.3fr_1fr]">
          <Reveal>
            <div>
              <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#E9C88A]">12 — Contact</span>
              <h2 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1.05] text-slate-100">Let's build <span className="italic gold-text">what's next.</span></h2>
              <p className="mt-6 max-w-xl text-base md:text-lg text-slate-400 leading-relaxed">
                Whether you are an entrepreneur, an investor, a business owner, a government institution, a technology builder, a strategic partner — or simply someone with an idea worth exploring. Let's talk.
              </p>
              <button onClick={() => scrollToId("impact")} data-testid="footer-query-button" className="group mt-8 inline-flex items-center gap-2 rounded-full bg-[#E9C88A] px-7 py-3.5 text-sm font-semibold text-[#0A0D14] hover:bg-[#f5dda9] transition-colors">
                Send a General Query <ArrowUpRight size={14} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </button>
            </div>
          </Reveal>
          <Reveal delay={0.12}>
            <div className="space-y-3">
              {CONTACTS.map((c) => (
                <a key={c.label} href={c.href} target="_blank" rel="noopener noreferrer" data-testid={c.testid} className="group flex items-center gap-4 rounded-xl border border-white/8 bg-[#10141d] px-5 py-4 hover:border-[#E9C88A]/40 transition-colors">
                  <c.icon size={18} className="text-[#E9C88A]" />
                  <div className="flex-1">
                    <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-slate-500">{c.label}</div>
                    <div className="text-sm font-medium text-slate-200 group-hover:text-[#E9C88A] transition-colors">{c.value}</div>
                  </div>
                  <ArrowUpRight size={15} className="text-slate-600 group-hover:text-[#E9C88A] transition-colors" />
                </a>
              ))}
            </div>
          </Reveal>
        </div>
        <div className="mt-20 flex flex-col items-center justify-between gap-6 border-t border-white/5 pt-8 sm:flex-row">
          <div className="flex items-center gap-3">
            <Logo size={30} />
            <div className="leading-tight">
              <div className="font-display text-sm font-semibold text-slate-200">Bishwa Mohan Pati</div>
              <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">Building Businesses · Connecting Markets · Creating Impact</div>
            </div>
          </div>
          <div className="flex items-center gap-5 text-xs text-slate-500">
            <span>© {new Date().getFullYear()} Bishwa Mohan Pati</span>
            <a href="/admin" className="hover:text-[#E9C88A] transition-colors" data-testid="footer-admin-link">Admin</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
